
import { useContext, useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next'
import { CRIcon, CRRender } from '../crRender';
import { DomainContext } from '../../context/DomainContext';
import "./style.css"

const ActionBtn = ({ onApply, title, className = "", isDisabled, icon }) => {
    const { t } = useTranslation()
    const { loading } = useContext(DomainContext)
    const [isBtnLoading, setIsBtnLoading] = useState(false)

    useEffect(() => {
        if (!loading && isBtnLoading) setIsBtnLoading(false)

    }, [loading, isBtnLoading])

    const handleClick = useCallback(() => {

        if (isBtnLoading || loading ||isDisabled) return
        setIsBtnLoading(true)
        onApply?.()
    }, [isBtnLoading, loading, onApply])

    return (
        <CRRender isRender={onApply}>
            <div className={`popup-btn ${className} pointer  ${isDisabled ? "not-allowed" : ""}`} onClick={handleClick} disabled={isBtnLoading  || isDisabled}>
                <CRIcon isRender={loading &&isBtnLoading} icon={"mdi:loading"} />
                <CRIcon className="action-btn-icon" isRender={!!icon} icon={icon} />
                {t(title)}
            </div>
        </CRRender>
    )
}

export default ActionBtn